import { RadioGroupNew, RadioButtonNew } from "@octopusdeploy/design-system-components";
import type { Repository, UpgradeConfigurationResource } from "@octopusdeploy/octopus-server-client";
import { UpgradeNotificationMode } from "@octopusdeploy/octopus-server-client";
import { useEffect } from "react";
import { Form, useForm } from "~/components/form/Form/Form";
import { WorkflowContent } from "~/workflows/WorkflowContent";
import { workflows } from "~/workflows/workflows";
interface UpdateNotificationsWorkflowProps {
    loaderData: UpgradeConfigurationResource | null;
    completeWorkflow: (upgradeConfiguration: UpgradeConfigurationResource) => void;
}
export const updateNotificationsWorkflowLoader = (repository: Repository) => repository.UpgradeConfiguration.get();
export const UpdateNotificationsWorkflow: React.FC<UpdateNotificationsWorkflowProps> = ({ loaderData, completeWorkflow }) => {
    const { model, setModel, formProps, createSaveAction } = useForm<UpgradeConfigurationResource | null, UpgradeConfigurationResource>({
        formName: "Upgrade Notifications Configuration",
        initialModel: null,
        disableSnackbar: true,
        onSubmit: (repository, model) => {
            if (!model) {
                throw new Error("Upgrade Notifications form submission failed: model is null.");
            }
            return repository.UpgradeConfiguration.modify(model);
        },
        afterSubmit: async (_, output) => {
            completeWorkflow(output);
        },
        updateFormModelAfterSubmit: (model) => model,
    });
    useEffect(() => {
        if (loaderData) {
            setModel(loaderData);
        }
    }, [loaderData, setModel]);
    return (<WorkflowContent.Dialog workflow={workflows.updateNotificationsWorkflow} title="Upgrade Notifications" primaryAction={createSaveAction()}>
            <Form {...formProps}>
                {model && (<RadioGroupNew value={model.NotificationMode} onChange={(notificationMode) => setModel({ ...model, NotificationMode: notificationMode })} label="" description="This setting only affects the visibility of the update notification that is shown in the top menu when Octopus updates are available.">
                        <RadioButtonNew name="notificationMode" value={UpgradeNotificationMode.AlwaysShow} label="Always show updates"/>
                        <RadioButtonNew name="notificationMode" value={UpgradeNotificationMode.ShowOnlyMajorMinor} label="Only show major or minor version updates"/>
                        <RadioButtonNew name="notificationMode" value={UpgradeNotificationMode.NeverShow} label="Never show updates"/>
                    </RadioGroupNew>)}
            </Form>
        </WorkflowContent.Dialog>);
};
UpdateNotificationsWorkflow.displayName = "UpdateNotificationsWorkflow"
